import react, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import HttpClient from '../../../../services/HttpClient'
import Button from '../../../../components/Button/Button'

export default function () {
  const navigate = useNavigate()
  const [errors, setErrors] = useState([])
  const [title, setTitle] = useState('')
  const [elevation, setElevation] = useState(0)

  const onSubmit = async (event) => {
    event.preventDefault()
    setErrors([])

    if (!title) return setErrors(['Title is required'])
    if (!elevation) return setErrors(['Clan is required'])

    const data = {
      title,
      elevation,
    }

    const response = await HttpClient().post('/api/v1/dashboard/characters/create/rank', data)
    navigate(`/dashboard`)
  }

  return (
    <div className="page">
      <div className="page__title">New rank</div>
      <form className="form" onSubmit={onSubmit}>
        <div className="form__group">
          <label className="form__label">Title</label>
          <input className="form__input" value={title} onChange={(e) => setTitle(e.target.value)} />
        </div>
        <div className="form__group">
          <label className="form__label">Elevation</label>
          <input className="form__input" value={elevation} onChange={(e) => setElevation(e.target.value)} />
        </div>
        <Button type="submit">Create</Button>
      </form>
    </div>
  )
}
